export default __webpack_public_path__ + "media/images/theme/wordmark_light-33b7370af189537393e088d30777555b.png";